import { SxProps } from '@mui/material';
import { black, grey7, grey8 } from 'app/components/ThemeProvider/colors';

export const inputInfo: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  mb: '8px',
  color: grey7,

  '@media screen and (max-height: 864px)': {
    mb: '6px',
  },
};

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};
export const descText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '17px',
  mb: '22px',
  fontWeight: '400',
  color: grey8,
};

export const btnBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
};

export const modalBoxPaper: SxProps = {
  p: '50px 40px',
};

export const modalBoxContent: SxProps = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  p: '0',
  mb: '64px',
};

export const modalBoxText: SxProps = {
  fontFamily: 'Yelo',
  color: black,
  fontSize: '26px',
  fontWeight: '500',
};

export const modalBoxDesc: SxProps = {
  fontFamily: 'Yelo',
  color: grey8,
  fontSize: '17px',
  fontWeight: '400',
};
